import axios from 'axios'

const get = (path) => axios.get(path)

const post = (path, body) => axios.post(path, body)

const put = (path, body) => axios.put(path, body)

const del = (path) => axios.delete(path)

export default { get, post, put, del }